import { LoadingLottie } from '@/components/loading'
import { Button } from '@/components/ui/button'
import RenderIf from '@/components/ui/render-if'
import { WalletInfo } from '@/config'
import { cn } from '@/lib'
import { INetwork } from '@/types'

type Props = {
  accepted: boolean
  setAccepted: (v: boolean) => void
  showCancelButton: boolean
  isConnecting: boolean
  handleCancel: () => void
  handleConnect: (selectedWallet: string | null, selectedWalletInfo: WalletInfo | null) => void
  isConnected: boolean
  selectedNetwork: INetwork | null
  selectedWallet: string | null
  selectedWalletInfo: WalletInfo | null
}

export default function Footer({
  accepted,
  showCancelButton,
  isConnecting,
  handleCancel,
  handleConnect,
  isConnected,
  selectedNetwork,
  selectedWallet,
  selectedWalletInfo,
}: Props) {
  return (
    <>
      <div className='relative h-12 flex w-full items-center justify-center'>
        <RenderIf condition={showCancelButton && isConnecting}>
          <div
            className={cn(
              'duration-400 absolute left-0 w-1/2 transition-all ease-in-out',
              showCancelButton && isConnecting ? 'translate-x-0 opacity-100' : '-translate-x-full opacity-0'
            )}
          >
            <Button
              size='lg'
              variant='secondary'
              onClick={handleCancel}
              className='duration-400 w-[95%] rounded-xl cursor-pointer bg-surface-hard text-white-48-700 hover:bg-surface-hard/90'
            >
              Cancel
            </Button>
          </div>
        </RenderIf>
        <div
          className={cn(
            'duration-400 absolute transition-all ease-in-out',
            showCancelButton && isConnecting ? 'right-0 w-1/2' : 'right-1/2 w-full translate-x-1/2'
          )}
        >
          <Button
            size='lg'
            disabled={!selectedNetwork || !selectedWallet || isConnecting || !accepted}
            onClick={() => handleConnect(selectedWallet, selectedWalletInfo)}
            className='duration-300 w-full'
          >
            <RenderIf condition={isConnecting}>
              <div className='flex'>
                <LoadingLottie className='my-auto mr-1 size-4' />
                Connecting...
              </div>
            </RenderIf>
            {!isConnecting && (isConnected ? 'Disconnect Wallet' : 'Connect Wallet')}
          </Button>
        </div>
      </div>
    </>
  )
}
